import { render, staticRenderFns } from "./LbCorpolatePlanStep.vue?vue&type=template&id=6966e964&scoped=true&"
import script from "./LbCorpolatePlanStep.vue?vue&type=script&lang=js&"
export * from "./LbCorpolatePlanStep.vue?vue&type=script&lang=js&"
import style0 from "./LbCorpolatePlanStep.vue?vue&type=style&index=0&id=6966e964&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6966e964",
  null
  
)

export default component.exports